/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloBanco from 'Infotrack@Modelos/administracion/banco';
import IBanco from 'Infotrack@Modelos/administracion/banco/entidades/banco';

export default class ControladorModeloBanco {
    private modeloBanco: ModeloBanco;

    constructor() {
        this.modeloBanco = new ModeloBanco();
    }

    public consultarBanco() {
        return this.modeloBanco.consultarBanco().then(({ data: { Entidades } }) => Entidades);
    }

    public crearBanco(banco: IBanco) {
        return this.modeloBanco.crearBanco(banco);
    }

    public async editarBanco(banco: IBanco) {
        return this.modeloBanco.editarBanco(banco);
    }
    public async eliminarBanco(banco: IBanco) {
        await this.modeloBanco.eliminarBanco(banco);
    }

    public validarEntidad(banco: IBanco): boolean {
        if (banco.CodigoBanco === '' || banco.NombreBanco === '') {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }

        return true;
    }
}
